import React, { Component } from 'react';
import * as Sentry from "@sentry/react";

class CustomErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    Sentry.captureReactException(error, errorInfo);
  }

  render() {
    // @ts-ignore
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div className='w-screen h-screen flex flex-col justify-center items-center' >
            <h1>Something went wrong.</h1>
            <button className='px-4 py-1' onClick={
                
                () => {
                    // @ts-ignore
                    this.state.hasError = false;
                    window.location.reload();
                }
            }>Retry</button>
        </div>
      );
    }

    // @ts-ignore
    return this.props.children; 
  }
}

export default CustomErrorBoundary;